export const LUCIA_SOLICITA_ID = 13;
export const LUCIA_COLETA_ID = 14;

const LUCIA_SERVICO_IDS = [LUCIA_SOLICITA_ID, LUCIA_COLETA_ID];

export const isLuciaServicoId = (id) => LUCIA_SERVICO_IDS.includes(Number(id));

const flagBooleana = (flag) => {
  if (flag === true || flag === 1 || flag === '1') return true;
  if (flag === false || flag === 0 || flag === '0') return false;
  return null;
};

const produtoMarcado = (produto) => {
  if (produto && typeof produto === 'object' && Object.prototype.hasOwnProperty.call(produto, 'checked')) {
    return produto.checked !== false && produto.checked !== 0 && produto.checked !== '0';
  }
  return true;
};

export const clienteTemProdutoLucia = (produtos, produtoId) => {
  if (!Array.isArray(produtos)) {
    return false;
  }
  return produtos.some((produto) => {
    if (Number(produto?.id ?? produto) !== Number(produtoId)) {
      return false;
    }
    return produtoMarcado(produto);
  });
};

export const clienteTemLuciaSolicita = (produtos) => clienteTemProdutoLucia(produtos, LUCIA_SOLICITA_ID);

export const clienteTemLuciaColeta = (produtos) => clienteTemProdutoLucia(produtos, LUCIA_COLETA_ID);

export const servicoLuciaDisponivel = (flag, produtos, produtoId) => {
  const resolvido = flagBooleana(flag);
  if (resolvido !== null) {
    return resolvido;
  }
  return clienteTemProdutoLucia(produtos, produtoId);
};

export const hasLuciaColetaDocumentos = (infos) => {
  if (!infos) return false;
  if (Array.isArray(infos.documentos_coleta) && infos.documentos_coleta.length > 0) {
    return true;
  }
  if (Array.isArray(infos.servicos) && infos.servicos.some((s) => Number(s.produto_id) === LUCIA_COLETA_ID)) {
    return true;
  }
  if (Array.isArray(infos.pretendentes)) {
    return infos.pretendentes.some((p) => {
      if (Number(p.servico_id) === LUCIA_COLETA_ID) return true;
      const ativos = (p.produtos && p.produtos.ativo) || [];
      return ativos.some((prod) => Number(prod.id) === LUCIA_COLETA_ID || Number(prod.id) === 16);
    });
  }
  return false;
};

export const podeEnviarLaudoWhatsappLucia = (infos) => {
  if (!infos) return false;
  if (hasLuciaColetaDocumentos(infos)) {
    return true;
  }
  if (Array.isArray(infos.servicos) && infos.servicos.some((s) => isLuciaServicoId(s.produto_id))) {
    return true;
  }
  if (Array.isArray(infos.pretendentes)) {
    return infos.pretendentes.some((p) => isLuciaServicoId(p.servico_id));
  }
  return false;
};
